import * as Sentry from '@sentry/vue'
import { computedAsync } from '@vueuse/core'
import type { VirtualStation } from '~/types/virtual-station'

/**
 * Composable to fetch virtual stations for a city from server API
 * Uses computedAsync for reactive fetching with loading state
 *
 * @param cityId - Reactive city ID (e.g., 'berlin', 'paris')
 * @returns Reactive array of virtual stations (empty array on error)
 */
export function useVirtualStations(cityId: Ref<string>) {
  return computedAsync<VirtualStation[]>(async () => {
    try {
      return await $fetch<VirtualStation[]>(`/api/virtual-stations/${cityId.value}`)
    }
    catch (error) {
      Sentry.captureMessage(
        'Error while fetching virtual stations from server API',
        {
          level: 'error',
          extra: { cityId: cityId.value, error },
          tags: { operation: 'get-virtual-stations' },
        },
      )
      console.error('[Virtual Stations] Fetch error:', error)
      return []
    }
  }, []) // Empty array as initial value
}
